import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ioDispatcher() {
  return Dispatchers_getInstance().b14_1;
}
//region block: exports
export {
  ioDispatcher as ioDispatcher3b9pa3x0duop,
};
//endregion

//# sourceMappingURL=IODispatcher.web.mjs.map
